require("appdev/wizards/school_org_usage_data.scss");

class SchoolOrgUsageData extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		this.state = {};
	}

	renderStatisticsRow(stats, entity_name, id) {
		return (
			<tr key={ id }>
				<td>{ entity_name }</td>
				<td>{ stats.meta_data.grade_levels }</td>
				<td>{ stats.meta_data.student_count }</td>
				<td>{ stats.meta_data.minute_count }</td>
				<td>{ stats.meta_data.quiz_count }</td>
				<td>{ this.roundPercent(stats.last_active.year) }</td>
				<td>{ this.roundPercent(stats.last_active.month) }</td>
				<td>{ this.roundPercent(stats.logs.year) }</td>
				<td>{ this.roundPercent(stats.logs.month) }</td>
				<td>{ this.roundPercent(stats.quizzes.year) }</td>
				<td>{ this.roundPercent(stats.quizzes.month) }</td>
				<td>{ this.roundPercent(stats.writing.year) }</td>
				<td>{ this.roundPercent(stats.writing.month) }</td>
			</tr>
		);
	}
	roundPercent(decimal) {
		return (decimal * 100).toFixed(1) + "%";
	}

	render() {
		var schoolOrg = this.props.schoolOrg;

		var schoolOrgRow = this.renderStatisticsRow(schoolOrg.statistics, "Whole School", schoolOrg.id);
		var studentListRows = _.map(schoolOrg.active_student_lists, (student_list) => {
			return this.renderStatisticsRow(student_list.statistics, student_list.name, student_list.id);
		});

		var statisticsTable = (
			<table>
				<tbody>
					<tr>
						<th></th>
						<th>Grade Levels</th>
						<th>Total Students</th>
						<th>Total Minutes</th>
						<th>Total Quizzes</th>
						<th>1 Year Active</th>
						<th>30 Day Active</th>
						<th>1 Year Logs</th>
						<th>30 Day Logs</th>
						<th>1 Year Quizzes</th>
						<th>30 Day Quizzes</th>
						<th>1 Year Writing</th>
						<th>30 Day Writing</th>
					</tr>
					{ schoolOrgRow }
					{ studentListRows }
				</tbody>
			</table>
		);

		return (
			<div className="schoolOrgUsageData">
				{ statisticsTable }
			</div>
		);
	}
};

SchoolOrgUsageData.propTypes = PageStrictPropTypes({
	// school org with student_lists and stats
	schoolOrg: PropTypes.object.isRequired,
});

module.exports = SchoolOrgUsageData;


// WEBPACK FOOTER //
// ./modules/components/appdev/wizards/SchoolOrgUsageData.js